import { getProductInfo } from './productHelpers.js';

// Métricas de sugerencias (SOK-06): qué upsell y cross-sell se le muestran al cliente
// y a qué precio los acepta. El admin calcula la tasa de aceptación con estos datos.

/**
 * Ids únicos, en orden de aparición, de los productos que muestra el modal de cross-sell.
 * Un mismo producto puede venir sugerido por varios productos del carro.
 */
export function getCrossSellShownIds(products) {
  const ids = [];
  (products || []).forEach(product => {
    if (product && product.id && !ids.includes(product.id)) ids.push(product.id);
  });
  return ids;
}

/**
 * Ids únicos de los upsell que muestra la ficha de un producto. La lista de upsell
 * suele incluir al propio producto (la opción base), que no cuenta como sugerencia.
 */
export function getUpsellShownIds(productId, upsellItems) {
  const ids = [];
  (upsellItems || []).forEach(item => {
    const id = item && item.product_id;
    if (id && id !== productId && !ids.includes(id)) ids.push(id);
  });
  return ids;
}

/**
 * Precio unitario que ve el cliente en la sugerencia (precio común de la tienda, sin
 * modificadores), en la unidad menor de la moneda. `null` si el producto no tiene precio.
 */
export function getSuggestionUnitPrice(product, storeIds) {
  const { commonPrice } = getProductInfo(product, storeIds);
  return typeof commonPrice === 'number' && Number.isFinite(commonPrice) ? commonPrice : null;
}
